module.exports = __webpack_public_path__ + "img/risk_reward.6866563a.svg";